import BigModal from 'components/BigModal'
import GetStartedModal from 'components/GetStartedModal'
import { useAnalytics } from 'clientHelpers/context/analyticsContext'
import { cx } from '@emotion/css'
import { React, useState } from 'react'
import styles from './styles'

const WhitePricingSection = () => {
  const [isModalOpen, setModalOpen] = useState(false)

  const { addTrackingForCTA } = useAnalytics()

  const renderPricingCTAVersions = isDesktop => {
    return (
      <a
        {...addTrackingForCTA({
          action: 'Clicked view pricing',
          sourceDetail: 'pricing section',
          url: '/hire-developers/pricing',
        })}
        className={cx(styles.mainButton, isDesktop && styles.desktopButton)}>
        View pricing
      </a>
    )
  }

  return (
    <>
      <div className={styles.pricingContainer}>
        <div className={styles.leftCol}>
          <h2 className={styles.title}>
            <span className={styles.blueTitle}>Unlimited</span> hires
          </h2>
          <p className={styles.subtitle}>
            Make unlimited hires with year-round access to our curated marketplace of job-seeking developers.
          </p>
          {renderPricingCTAVersions(true)}
        </div>
        <div className={styles.rightCol}>
          <div className={styles.list}>
            <div className={styles.listItem}>
              <img
                src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/pricing_section/tick.png`}
                alt="Check icon"
                className={styles.listImage}
              />
              <p>Make unlimited developer hires.</p>
            </div>
            <div className={styles.listItem}>
              <img
                src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/pricing_section/tick.png`}
                alt="Check icon"
                className={styles.listImage}
              />
              <p>Dedicated hiring success manager</p>
            </div>
            <div className={styles.listItem}>
              <img
                src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/pricing_section/tick.png`}
                alt="Check icon"
                className={styles.listImage}
              />
              <p>Access to all developers, features and your success manager.</p>
            </div>
          </div>
          <div className={styles.listAction}>
            <strong>Want to explore?</strong>{' '}
            <a className={styles.listActionButton} onClick={() => setModalOpen(true)} type="button">
              Sign up
            </a>{' '}
            to chat to our team for a demo.
          </div>
        </div>
        <div className={styles.mobileButton}>{renderPricingCTAVersions(false)}</div>
      </div>

      <BigModal open={isModalOpen} handleClose={() => setModalOpen(false)}>
        {({ close }) => <GetStartedModal handleClose={close} />}
      </BigModal>
    </>
  )
}

export default WhitePricingSection
